/* MISSION mobile menu search v1 (Oct 2026). Works with sections/mission-mega-menu.liquid.
   Tapping the drawer search bar puts the drawer in search mode: bar on top with Cancel,
   rows + footer links hidden, results rendered by sections/mission-menu-search.liquid. */
(function () {
  'use strict';
  var SID = 'mission-menu-search';
  var FALLBACK = ['sentry-boat-fenders', 'reef-inflatable-water-mat', 'dreadknot-dock-line', 'cassi-gear-tote'];
  var CHEV = '<svg class="mm-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function esc(t) {
    return String(t || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function listFrom(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    var l = d.querySelector('[data-mms-list]');
    return l ? l.innerHTML.trim() : '';
  }

  function init(root) {
    var drawer = root.querySelector('[data-mm-drawer]');
    var mq = root.querySelector('[data-mm-mq]');
    if (!drawer || !mq || drawer.dataset.mmsInit) return;
    drawer.dataset.mmsInit = '1';
    var dsearch = mq.closest('.mm-dsearch');
    if (!dsearch) return;

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-mm-config]').textContent) || {}; } catch (e) {}
    var searchUrl = cfg.searchUrl || ROOT + 'search';
    var suggestUrl = cfg.predictiveSearchUrl || ROOT + 'search/suggest';
    var desktop = window.matchMedia('(min-width: 1024px)');

    var cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'mms-cancel';
    cancel.textContent = 'Cancel';
    dsearch.appendChild(cancel);

    var res = document.createElement('div');
    res.className = 'mms-res';
    res.setAttribute('data-mms-res', '');
    dsearch.parentNode.insertBefore(res, dsearch.nextSibling);

    var on = false, timer = null, ctl = null, bestP = null, seq = 0;

    function size() {
      if (!on) return;
      var vv = window.visualViewport;
      var top = parseFloat(getComputedStyle(drawer).top) || 0;
      var bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      drawer.style.setProperty('--mms-h', Math.max(220, Math.round(bottom - top)) + 'px');
    }

    function bestHandles() {
      var hs = String(cfg.bestSellerHandles || '').split(/[,\s]+/).filter(Boolean);
      FALLBACK.forEach(function (h) { if (hs.length < 4 && hs.indexOf(h) < 0) hs.push(h); });
      return hs.slice(0, 4);
    }
    function loadBest() {
      if (bestP) return bestP;
      bestP = Promise.all(bestHandles().map(function (h) {
        return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=' + SID)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(listFrom)
          .catch(function () { return ''; });
      })).then(function (a) { return a.join(''); });
      return bestP;
    }
    function bestBlock(rows, label) {
      return rows ? '<div class="mms-sec">' + (label ? '<div class="mms-hd">' + label + '</div>' : '') + rows + '</div>' : '';
    }

    function shortcuts(q) {
      var w = q.toLowerCase().split(/\s+/).filter(Boolean);
      return (cfg.shortcuts || []).filter(function (s) {
        var hay = ((s.label || '') + ' ' + (s.keywords || '')).toLowerCase();
        return w.every(function (x) { return hay.indexOf(x) > -1; });
      });
    }

    function render(raw) {
      var q = String(raw || '').trim();
      var my = ++seq;
      if (ctl) { ctl.abort(); ctl = null; }
      res.classList.remove('mms-load');
      if (!q) {
        return loadBest().then(function (rows) {
          if (my !== seq) return;
          res.innerHTML = bestBlock(rows, 'Best sellers');
          res.scrollTop = 0;
        });
      }
      ctl = window.AbortController ? new AbortController() : null;
      res.classList.add('mms-load');
      var url = suggestUrl + '?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=10' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=' + SID;
      return fetch(url, ctl ? { signal: ctl.signal } : {})
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(listFrom)
        .catch(function (e) { return e && e.name === 'AbortError' ? null : ''; })
        .then(function (rows) {
          if (rows === null || my !== seq) return;
          var jumps = shortcuts(q);
          var all = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
          var h = '';
          if (rows) h += '<div class="mms-sec"><div class="mms-hd">Products</div>' + rows + '</div>';
          if (jumps.length) {
            h += '<div class="mms-sec"><div class="mms-hd">Categories</div>' + jumps.map(function (j) {
              return '<a class="mm-row" href="' + esc(j.url) + '"><b>' + esc(j.label) + '</b>' + CHEV + '</a>';
            }).join('') + '</div>';
          }
          if (h) {
            h += '<a class="mms-all" href="' + esc(all) + '"><span>See all results for “' + esc(q) + '”</span>' + CHEV + '</a>';
            res.classList.remove('mms-load');
            res.innerHTML = h;
            res.scrollTop = 0;
            return;
          }
          return loadBest().then(function (best) {
            if (my !== seq) return;
            res.classList.remove('mms-load');
            res.innerHTML = '<p class="mms-none">No matches for “' + esc(q) + '”. Here are our best sellers.</p>' + bestBlock(best, '');
            res.scrollTop = 0;
          });
        });
    }

    function enter() {
      if (on || desktop.matches) return;
      on = true;
      drawer.classList.add('mms-on');
      size();
      render(mq.value);
    }
    function exit() {
      if (!on) return;
      on = false;
      seq++;
      clearTimeout(timer);
      if (ctl) { ctl.abort(); ctl = null; }
      drawer.classList.remove('mms-on');
      drawer.style.removeProperty('--mms-h');
      mq.value = '';
      res.innerHTML = '';
    }

    mq.addEventListener('focus', enter);
    /* Capture on the drawer so the mega menu's own input handler (old 2-up tiles) never runs. */
    drawer.addEventListener('input', function (e) {
      if (e.target !== mq || desktop.matches) return;
      e.stopPropagation();
      if (!on) enter();
      clearTimeout(timer);
      var v = mq.value;
      timer = setTimeout(function () { render(v); }, v.trim() ? 160 : 0);
    }, true);
    mq.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var q = mq.value.trim();
      if (q) window.location.href = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      else mq.blur();
    });
    cancel.addEventListener('click', function () { exit(); mq.blur(); });

    function dropKeyboard() { if (document.activeElement === mq) mq.blur(); }
    res.addEventListener('touchmove', dropKeyboard, { passive: true });
    res.addEventListener('wheel', dropKeyboard, { passive: true });

    window.addEventListener('resize', size);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', size);
      window.visualViewport.addEventListener('scroll', size);
    }
    new MutationObserver(function () {
      if (drawer.classList.contains('on')) loadBest();
      else exit();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    desktop.addEventListener && desktop.addEventListener('change', function (m) { if (m.matches) exit(); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mm-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
